import { render, staticRenderFns } from "./organic-gags-page.vue?vue&type=template&id=f6016a7c&scoped=true&lang=pug&"
import script from "./organic-gags-page.vue?vue&type=script&lang=js&"
export * from "./organic-gags-page.vue?vue&type=script&lang=js&"
import style0 from "./organic-gags-page.vue?vue&type=style&index=0&id=f6016a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6016a7c",
  null
  
)

export default component.exports